import { useTranslation } from "react-i18next";
import { cancellationPolicy, cancellationUi } from "@/lib/cancellation-policy";
import { useQuery } from "@tanstack/react-query";
import { getTourPolicy } from "@/lib/bokun-policy.functions";
import { calendarCopy } from "@/lib/calendar-copy";

/** Política de cancelación aprobada (o la de Bókun si es más flexible). */
export function CancellationPolicyBlock({ className = "", productId }: { className?: string; freeHours?: number | null; productId?: string | null }) {
  const { i18n } = useTranslation();
  const ui = cancellationUi(i18n.language);
  const policy = useQuery({queryKey:["tour-policy",productId,i18n.language],queryFn:()=>getTourPolicy({data:{id:productId ?? "",language:i18n.language}}),enabled:!!productId,staleTime:60_000,refetchInterval:60_000});
  const lines = productId ? policy.data?.lines ?? [policy.isError ? calendarCopy(i18n.language).error : calendarCopy(i18n.language).loading] : cancellationPolicy(i18n.language);
  return (
    <section className={`rounded-2xl border border-border bg-card p-5 ${className}`}>
      <h2 className="text-lg font-bold">{ui.title}</h2>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-muted-foreground">
        {lines.map((l) => (
          <li key={l}>{l}</li>
        ))}
      </ul>
    </section>
  );
}
